import { lazy, Suspense } from "react";
import "./styles.css";
import { Card, CardContent } from "@/components/ui/card";
import { Toaster } from "@/components/ui/sonner";
import { HomePage } from "@/pages/HomePage";
import { VoterAccessPage } from "@/pages/VoterAccessPage";

const StackAuthArea = lazy(() => import("@/pages/StackAuthArea").then((module) => ({ default: module.StackAuthArea })));

export function App() {
  const route = parseRoute(window.location.pathname);
  let content;

  if (route.name === "vote") {
    content = <VoterAccessPage conventionSlug={route.conventionSlug} sessionCode={route.sessionCode} token={route.token} />;
  } else if (route.name === "admin" || route.name === "handler") {
    content = (
      <Suspense fallback={<FullPageLoading label="Chargement de l'espace admin..." />}>
        <StackAuthArea route={route} />
      </Suspense>
    );
  } else {
    content = <HomePage />;
  }

  return (
    <>
      {content}
      <Toaster position="top-right" />
    </>
  );
}

function FullPageLoading({ label }: { label: string }) {
  return (
    <main className="grid min-h-screen place-items-center bg-background px-4">
      <Card className="bg-card/90">
        <CardContent role="status" aria-live="polite" aria-busy="true" className="p-6 text-sm text-muted-foreground">{label}</CardContent>
      </Card>
    </main>
  );
}

function parseRoute(pathname: string) {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] === "admin") {
    return { name: "admin" as const };
  }

  if (segments[0] === "handler") {
    return { name: "handler" as const };
  }

  if (segments[0] === "vote" && segments[1] && segments[2] && segments[3]) {
    return {
      name: "vote" as const,
      conventionSlug: decodeURIComponent(segments[1]),
      sessionCode: decodeURIComponent(segments[2]),
      token: decodeURIComponent(segments.slice(3).join("/"))
    };
  }

  if (segments[0] === "vote" && segments[1] && segments[2]) {
    return {
      name: "vote" as const,
      conventionSlug: null,
      sessionCode: decodeURIComponent(segments[1]),
      token: decodeURIComponent(segments.slice(2).join("/"))
    };
  }

  return { name: "home" as const };
}
